"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShardInRange = exports.getShard = void 0;
const md5 = require("md5");
function getShard(input, subjectShards) {
    const hashOutput = md5(input);
    // get the first 4 bytes of the md5 hex string and parse it using base 16
    // (8 hex characters represent 4 bytes, e.g. 0xffffffff represents the max 4-byte integer)
    const intFromHash = parseInt(hashOutput.slice(0, 8), 16);
    return intFromHash % subjectShards;
}
exports.getShard = getShard;
function isShardInRange(shard, range) {
    return shard >= range.start && shard < range.end;
}
exports.isShardInRange = isShardInRange;
//# sourceMappingURL=shard.js.map